/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function RoleCommenter({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M3.4 5.5a.6.6 0 0 1 .6-.6h8a.6.6 0 1 1 0 1.2H4a.6.6 0 0 1-.6-.6ZM3.4 8.5a.6.6 0 0 1 .6-.6h6a.6.6 0 1 1 0 1.2H4a.6.6 0 0 1-.6-.6Z" /><path fill="currentColor" fillRule="evenodd" d="M13 1.4A2.6 2.6 0 0 1 15.6 4v6a2.6 2.6 0 0 1-2.6 2.6H7.652a1.4 1.4 0 0 0-.9.329l-2.673 2.248a.6.6 0 0 1-.987-.46V12.6H3A2.6 2.6 0 0 1 .4 10V4A2.6 2.6 0 0 1 3 1.4h10ZM14.4 4A1.4 1.4 0 0 0 13 2.6H3A1.4 1.4 0 0 0 1.6 4v6A1.4 1.4 0 0 0 3 11.4h.692a.6.6 0 0 1 .6.6v1.429L5.98 12.01a2.6 2.6 0 0 1 1.673-.61H13a1.4 1.4 0 0 0 1.4-1.4V4Z" clipRule="evenodd" /></svg>;
}
;